'use client';

import { useCallback } from 'react';

import { useDrawerStore, useModalStore } from '@/stores';

import { PrizeModal, type PrizeQueuePosition } from '../PrizeModal';

type ShowPrizeModalParams = {
  prizeLabel: string;
  isBigGain?: boolean;
  showFireworks?: boolean;
  onModalClose?: () => void;
  capitalizer?: string | null;
  hardClose?: boolean;
  queuePosition?: PrizeQueuePosition;
};

export const usePrizeModal = () => {
  const openModal = useModalStore((state) => state.openModal);
  const closeModal = useModalStore((state) => state.closeModal);
  const closeCurrentDrawer = useDrawerStore((state) => state.closeCurrentDrawer);

  const showPrizeModal = useCallback(
    ({
      prizeLabel,
      isBigGain = false,
      showFireworks,
      onModalClose,
      capitalizer,
      hardClose = false,
      queuePosition,
    }: ShowPrizeModalParams) => {
      closeCurrentDrawer();

      const modalId = openModal({
        showCloseButton: false,
        hardClose,
        priority: 100,
        className: '!h-auto !max-h-none w-full max-w-md mx-auto my-auto p-4',
        Component: () => (
          <PrizeModal
            prizeLabel={prizeLabel}
            queuePosition={queuePosition}
            isBigGain={isBigGain}
            showFireworks={showFireworks}
            capitalizer={capitalizer}
            onClose={() => {
              closeModal(modalId);
              // Chama o callback adicional quando o modal é fechado
              onModalClose?.();
            }}
          />
        ),
      });

      return modalId;
    },
    [openModal, closeModal, closeCurrentDrawer],
  );

  return { showPrizeModal };
};
